import authAxios from '@services/authAxios';

const fetchTrxCode = async () => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/configuration/trxcode/list`,
    });

    return data?.data?.page_data;
};

export default fetchTrxCode;
